import { useEffect, useLayoutEffect, useRef } from 'react';
import { debounce } from 'lodash';
export function useFooterAutoWidth(props) {
    const { footerId, containerId } = props || {};
    const hasContainer = !!document.getElementById(containerId);
    const observer = useRef();
    const setFooterWidth = () => {
        const footerDom = document.getElementById(footerId);
        const formDom = document.getElementById(containerId);
        const formWidth = formDom?.getBoundingClientRect?.()?.width;
        if (footerDom && typeof formWidth === 'number') {
            footerDom.style.width = `${formWidth}px`;
        }
    };
    const debounceSetFooterWidth = debounce(() => {
        setFooterWidth();
    }, 500, {
        leading: true,
    });
    const addResizeListener = () => {
        const formDom = document.getElementById(containerId);
        if (ResizeObserver && formDom) {
            const resizeObserver = new ResizeObserver((entries) => {
                entries.forEach(() => {
                    debounceSetFooterWidth();
                });
            });
            observer.current = resizeObserver;
            resizeObserver.observe(formDom);
        }
    };
    useEffect(() => {
        if (hasContainer && !observer.current) {
            addResizeListener();
        }
    }, [hasContainer]);
    useLayoutEffect(() => {
        setTimeout(() => {
            setFooterWidth();
            addResizeListener();
        }, 300);
        return () => {
            observer.current?.disconnect();
        };
    }, []);
}
